import { ExclamationCircleOutlined } from "@ant-design/icons"
import { Alert, Button } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

export const PurchaseRequestDeprecationBanner = () => {
    const { t } = useTranslation()

    const onClickMoreInfo = () => {
        window.open(t("info:purchase_request:deprecation.link"), "_blank")
    }

    return (
        <Alert
            type="warning"
            className="mb-40 items-center"
            closable={false}
            showIcon={true}
            icon={
                <div className="self-start">
                    <ExclamationCircleOutlined style={{ fontSize: "24px" }} />
                </div>
            }
            message={<span className="font-bold">{t("info:purchase_request.deprecation.title")}</span>}
            description={
                <div className="pr-5">
                    <p>{t("info:purchase_request.deprecation.description")}</p>
                </div>
            }
            action={
                <Button onClick={onClickMoreInfo} type="primary">
                    {t("info:purchase_request:deprecation.more_info")}
                </Button>
            }
        />
    )
}
